export default class CashierService {
  constructor(client) {
    this.apiClient = client;
  }

  async sendSMSReceipt(receiptRequest) {
    return this.apiClient.post("cashierreceipt/sms", receiptRequest, {
      headers: { "Content-Type": "application/json" },
    });
  }

  async getReceiptDetails(parkingActivityId) {
    return this.apiClient.get(`cashierreceipt/getreceipt/${parkingActivityId}`);
  }
  
  async sendEmailReceipt(receiptRequest) {
    return this.apiClient.post("cashierreceipt/email", receiptRequest, {
      headers: { "Content-Type": "application/json" },
    });
  }
}
